export type HorarioInicialStatus = 'disponivel' | 'ocupado' | 'reservadoAgendaOnline'

export function getHorarioInicialStatus(
  horario: Date | undefined,
  horariosMap: Map<Date, { isOcupado: boolean; isReservadoAgendaOnline: boolean }>,
  verificarReservasAgendaOnline: boolean
): HorarioInicialStatus {
  const info = horario ? horariosMap.get(horario) : undefined
  if (info?.isOcupado) return 'ocupado'
  if (verificarReservasAgendaOnline && info?.isReservadoAgendaOnline) return 'reservadoAgendaOnline'
  return 'disponivel'
}
